import ProjectStackProps, { Position } from "../../model/project-stack-props";
import Grid from '@mui/material/Grid';
import { nanoid } from 'nanoid'
const paddingSpace = 10;

export default function ProjectStack(props: ProjectStackProps){

    return (
        <Grid 
                key={nanoid()} 
                container 
                justifyContent={'center'} 
                alignItems={"center"}
                sx={{ 
                        paddingLeft: !props.isMobile ? 
                            (props.position === Position.LEFT ? 0 : (paddingSpace * 5))
                        : 0, 
                        paddingRight: !props.isMobile ?
                            (props.position === Position.RIGHT ? 0 : (paddingSpace * 5))
                        : 0,
                        marginTop: !props.isMobile?
                            (props.isStart ? 0 : -15)
                        : 10,
                    }}
                
                
                >
            <img src={props.path} alt={props.alt} height={867/1.8} width={596/1.8}/>
        </Grid>
    );
}